var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LoggableClass } from "../../log.decorator";
let Mutex = class Mutex {
    _locking;
    _locks;
    constructor() {
        this._locking = Promise.resolve();
        this._locks = 0;
    }
    isLocked() {
        return this._locks > 0;
    }
    lock() {
        this._locks += 1;
        let unlockNext;
        const willLock = new Promise((resolve) => (unlockNext = () => {
            this._locks -= 1;
            resolve();
        }));
        const willUnlock = this._locking.then(() => unlockNext);
        this._locking = this._locking.then(() => willLock);
        return willUnlock;
    }
};
Mutex = __decorate([
    LoggableClass()
], Mutex);
export { Mutex };
//# sourceMappingURL=Mutex.js.map